import { useNavigate } from "react-router-dom";
import PageShell from "../../../components/PageShell";
import { RestoreAccessForm } from "../../../components/RestoreAccess";
import { useTranslation } from "../../../i18n";

export default function RestoreAccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageShell title={t("nav.restoreAccess")}>
      <RestoreAccessForm
        onSuccess={() => navigate("/dashboard/admin/recent-customer")}
      />
    </PageShell>
  );
}
